(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BU_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', (e) => {
    const utility_bar = document.querySelector('.utility-bar');
    if (utility_bar) {
      function setHeaderInfoOffset() {
        // const bh = utility_bar.getBoundingClientRect().height;
        const bh = utility_bar.offsetHeight;
        document.documentElement.style.setProperty('--header-info-offset', `${bh}px`);
      }
      setHeaderInfoOffset();
      window.addEventListener('resize', setHeaderInfoOffset());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (e) => {
    const slider = document.querySelector('.featured-collection .swiper');
    if (slider) {
      const swiper = new Swiper(slider, {
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initSearchMenu() {
    const container = document.querySelector('.search-menu');
    const header_control = container.querySelector('.search-menu__control');
    const header_control_inner = header_control.querySelector('.swiper-wrapper');
    const sections = container.querySelectorAll('.search-menu__section');
    const categories = [...sections].map((elem) => {
      return elem.dataset.categoryTitle;
    });
    const toggle_button = document.querySelector('.menu-button--search');
    const OPEN_CLASS = 'is-search-menu-open';

    let last_index = null;

    // console.log(categories);
    categories.forEach((cat_title) => {
      const _button = document.createElement('BUTTON');
      const _span = document.createElement('SPAN');
      _button.classList.add('swiper-slide');
      _span.textContent = cat_title;
      _button.append(_span);
      header_control_inner.append(_button);
    });

    function updateHistory() {
      requestAnimationFrame(() => {
        if (search_menu_main != null) {
          const _url = new URL(location.href);
          if (isMenuOpen()) {
            if (last_index != search_menu_main.realIndex) {
              last_index = search_menu_main.realIndex;
              const category_str = categories[last_index];
              _url.hash = `#navigation_${category_str}`;
              history.replaceState(null, null, _url.toString());
            }
          } else {
            if (last_index != null) {
              last_index = null;
              _url.hash = '';
              history.replaceState(null, null, _url.toString());
            }
          }
        }
      });
    }

    const header_control_swiper = new Swiper(header_control, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const search_menu_main = new Swiper('.search-menu__inner', {
      direction: 'vertical',
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: true,
      thumbs: {
        swiper: header_control_swiper,
      },
      on: {
        progress: updateHistory,
      },
    });

    const search_keyword_list = new Swiper('.search-menu__keywords', {
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: true,
      spaceBetween: '8',
    });

    [...document.querySelectorAll('.search-menu__articles')].forEach((article_slider) => {
      article_slider._slider = new Swiper(article_slider, {
        slidesPerView: 'auto',
        freeMode: true,
      });
    });

    function isMenuOpen() {
      return document.querySelector('body').classList.contains(OPEN_CLASS);
    }

    function openMenu(primary_index = null) {
      document.querySelector('body').classList.add(OPEN_CLASS);

      if (primary_index != null) {
        // hash に直前セクションの記録があった場合
        header_control_swiper.slideTo(primary_index, 0);
        search_menu_main.slideTo(primary_index, 0);
        if (document.querySelector('.header-slider-control')) {
          document.querySelector('.header-slider-control').style.display = 'none'; // ヘッダーの元のコントロールを非表示に
        }
      } else {
        if (document.querySelector('.header-slider-control')) {
          // トップページでメインスライダーが動いている場合その状態をメニューに反映
          const index_main_slider = document.querySelector('.index-main-slider.swiper-initialized');
          if (index_main_slider && index_main_slider.swiper.slides[index_main_slider.swiper.realIndex] != null) {
            const sub_slider =
              index_main_slider.swiper.slides[index_main_slider.swiper.realIndex].querySelector('.index-sub-slider');
            if (sub_slider) {
              const current_category_title = sub_slider.dataset.categoryTitle;
              const on_search_menu_category_index = categories.indexOf(current_category_title);
              if (on_search_menu_category_index >= 0) {
                search_menu_main.slideTo(on_search_menu_category_index, 0);
              }
            }
          }
          const header_slider = document.querySelector('.header-slider-control');
          if (header_slider) {
            const header_slider_swiper = header_slider.swiper;
            if (header_slider_swiper != null) {
              const _translate = header_slider_swiper.getTranslate();
              setTimeout(() => {
                requestAnimationFrame(() => {
                  header_control_swiper.translateTo(_translate, 0);
                });
              }, 0);
            }
            header_slider.style.display = 'none'; // ヘッダーの元のコントロールを非表示に
          }
        }
      }
    }

    function closeMenu() {
      document.querySelector('body').classList.remove(OPEN_CLASS);
      updateHistory();
      if (document.querySelector('.header-slider-control')) {
        document.querySelector('.header-slider-control').style.display = 'block';
      }
    }

    function toggleMenu() {
      if (document.querySelector('body').classList.contains(OPEN_CLASS)) {
        closeMenu();
      } else {
        openMenu();
      }
    }
    toggle_button.addEventListener('click', toggleMenu);

    // 初期値に#navigation_ががある場合
    if (location.hash != '') {
      const hash_on_open = location.hash;
      if (/^#navigation_/.test(hash_on_open)) {
        const hash_array = hash_on_open.split('_');
        const hash_dest = hash_array[1];
        const primary_index = categories.indexOf(hash_dest);
        if (primary_index >= 0) {
          console.log(hash_dest, primary_index);
          openMenu(primary_index);
        }
      }
    }
  }
  document.addEventListener('DOMContentLoaded', initSearchMenu, {
    once: true,
  });

  // ヘッダーの戻るリンクの遷移先設定
  function forceHistoryBack(e) {
    e.preventDefault();
    // console.log('forceHistoryBack');

    history.back();
    return;
  }

  function initHeaderBackLink(e = null) {
    console.log(e);

    const referrer = document.referrer;
    console.log(document.referrer);

    const prev_url = new URL(referrer);
    const current_url = new URL(location.href);

    prev_url.search = '';
    current_url.search = '';

    const regexp = new RegExp('^' + current_url.toString(), 'i');
    const header_back_links = document.querySelectorAll('.header__back, .header__close');
    // console.log('referrer:', prev_url.toString());
    // console.log('current:', current_url.toString());
    // console.log(regexp.test(prev_url.toString()));

    // 一旦リセット
    [...header_back_links].forEach((elem) => {
      elem.classList.remove('is-history-back');
      elem.removeEventListener('click', forceHistoryBack);
    });

    if (
      prev_url.host == current_url.host &&
      regexp.test(prev_url.toString()) == false &&
      /\/products\//gi.test(prev_url.toString()) == false
    ) {
      [...header_back_links].forEach((elem) => {
        elem.classList.add('is-history-back');
        elem.addEventListener('click', forceHistoryBack, {
          url: prev_url.toString(),
        });
      });
    }
  }
  document.addEventListener('DOMContentLoaded', initHeaderBackLink, {
    once: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function initHeroSlider() {
    const hero_slider_elem = document.querySelector('.article-hero-slider');
    const pagination = hero_slider_elem.querySelector('.article-hero-slider__pagination');
    function adjustPaginationPosition(swiper) {
      const pagination_rect = pagination.getBoundingClientRect();
      const scroll_height = pagination.scrollHeight;
      const position_adjust = swiper.activeIndex - swiper.previousIndex > 0 ? 3.5 : 0;
      const bullets = swiper.pagination.bullets;
      const active_bullet = bullets[Math.min(swiper.activeIndex, bullets.length - 1)];
      const active_bullet_rect = active_bullet.getBoundingClientRect();

      // console.log(
      //   position_adjust,
      //   pagination_rect.height,
      //   active_bullet_rect.top,
      //   pagination.scrollTop,
      //   scroll_height
      // );

      if (pagination_rect.height < scroll_height) {
        const pagination_st = pagination.scrollTop;
        const pagination_area_center = pagination_rect.height / 2 - pagination_rect.width * 3 * 0.5;
        const centered_scroll_position = Math.max(
          Math.min(
            pagination_st +
              active_bullet_rect.top -
              pagination_rect.top -
              pagination_area_center -
              position_adjust * pagination_rect.width,
            scroll_height
          ),
          0
        );
        // console.log(centered_scroll_position);
        pagination.classList.add('is-overflowed');
        pagination.scrollTo({ top: centered_scroll_position, behavior: 'smooth' });
      } else {
        pagination.classList.remove('is-overflowed');
        pagination.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    const hero_slider = new Swiper(hero_slider_elem, {
      direction: 'vertical',
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      parallax: true,
      speed: 600,
      slidesPerView: 1,
      watchOverflow: true,
      pagination: {
        el: pagination,
      },
      on: {
        touchStart: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointerdown') {
              swiper._touch_start_y = evt.clientY;
            } else {
              swiper._touch_start_y = evt.touches[0].clientY;
            }
          }
        },
        touchMove: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointermove') {
              swiper._touch_move_y = evt.clientY;
            } else {
              swiper._touch_move_y = evt.touches[0].clientY;
            }
          }
        },
        touchEnd: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
              const delta_y = swiper._touch_move_y - swiper._touch_start_y;
              swiper._touch_start_y = null;
              swiper._touch_move_y = null;
              if (hero_slider_elem.lock_edge_function == false) {
                if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                  console.log('DOWN');
                  // mainSliderEdgeSlideNext();
                } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                  console.log('UP');
                  // mainSliderEdgeSlidePrev();
                }
              }
            }
          }
        },
        progress: (swiper, progress) => {
          if (progress < 0) {
            console.log('UP');
            // mainSliderEdgeSlidePrev();
          } else if (progress > 1) {
            // mainSliderEdgeSlideNext();
            const scrl_to = Math.max(
              document.querySelector('.article-template').scrollTop,
              swiper.maxTranslate() * (progress - 1) * -2
            );
            document.querySelector('.article-template').scrollTo({
              top: scrl_to,
              behavior: 'smooth',
            });
          }
        },
        transitionStart: (swiper) => {
          adjustPaginationPosition(swiper);
        },
      },
    });

    function checkArticleContainerPosition() {
      const offset = 30;
      const articleContainer = document.querySelector('.article-body');
      if (articleContainer) {
        const rect = articleContainer.getBoundingClientRect();
        if (rect.top < 0) {
          hero_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
          hero_slider.lockEdgeFunction = true;
          hero_slider.disable();
        } else {
          hero_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
          hero_slider.lockEdgeFunction = false;
          hero_slider.enable();
        }
        requestAnimationFrame(checkArticleContainerPosition);
      }
    }
    checkArticleContainerPosition();
  }
  window.addEventListener('load', initHeroSlider);

  function initArticleRecommendSlider() {
    const slider = document.querySelector('.article-recommend__list.swiper');
    if (slider) {
      const swiper = new Swiper(slider, {
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
      });
    }
  }
  window.addEventListener('load', initArticleRecommendSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function initBlogSlider() {
    const blog_slider = document.querySelector('.blog-slider');
    if (!blog_slider) return false;
    const pagination = blog_slider.querySelector('.blog-slider__pagination');
    function adjustPaginationPosition(swiper) {
      const pagination_rect = pagination.getBoundingClientRect();
      const scroll_height = pagination.scrollHeight;
      const position_adjust = swiper.activeIndex - swiper.previousIndex > 0 ? 3.5 : 0;
      const bullets = swiper.pagination.bullets;
      const active_bullet = bullets[Math.min(swiper.activeIndex, bullets.length - 1)];
      const active_bullet_rect = active_bullet.getBoundingClientRect();

      // console.log(
      //   position_adjust,
      //   pagination_rect.height,
      //   active_bullet_rect.top,
      //   pagination.scrollTop,
      //   scroll_height
      // );

      if (pagination_rect.height < scroll_height) {
        const pagination_st = pagination.scrollTop;
        const pagination_area_center = pagination_rect.height / 2 - pagination_rect.width * 3 * 0.5;
        const centered_scroll_position = Math.max(
          Math.min(
            pagination_st +
              active_bullet_rect.top -
              pagination_rect.top -
              pagination_area_center -
              position_adjust * pagination_rect.width,
            scroll_height
          ),
          0
        );
        // console.log(centered_scroll_position);
        pagination.classList.add('is-overflowed');
        pagination.scrollTo({ top: centered_scroll_position, behavior: 'smooth' });
      } else {
        pagination.classList.remove('is-overflowed');
        pagination.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    blog_slider.slider = new Swiper(blog_slider, {
      direction: 'vertical',
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      parallax: true,
      speed: 600,
      slidesPerView: 1,
      watchOverflow: true,
      pagination: {
        el: pagination,
        // clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 3,
      },
      on: {
        touchStart: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointerdown') {
              swiper._touch_start_y = evt.clientY;
            } else {
              swiper._touch_start_y = evt.touches[0].clientY;
            }
          }
        },
        touchMove: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointermove') {
              swiper._touch_move_y = evt.clientY;
            } else {
              swiper._touch_move_y = evt.touches[0].clientY;
            }
          }
        },
        touchEnd: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
              const delta_y = swiper._touch_move_y - swiper._touch_start_y;
              swiper._touch_start_y = null;
              swiper._touch_move_y = null;
              if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                console.log('DOWN');
                // mainSliderEdgeSlideNext();
              } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                console.log('UP');
                // mainSliderEdgeSlidePrev();
              }
            }
          }
        },
        progress: (swiper, progress) => {
          if (progress < 0) {
            // mainSliderEdgeSlidePrev();
          } else if (progress > 1) {
            // mainSliderEdgeSlideNext();
          }
        },
        transitionStart: (swiper) => {
          adjustPaginationPosition(swiper);
        },
      },
    });

    function checkArticleContainerPosition() {
      const offset = 30;
      const articleContainer = document.querySelector('.article-body');
      if (articleContainer) {
        const rect = articleContainer.getBoundingClientRect();
        if (rect.top < 0) {
          hero_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
          hero_slider.lockEdgeFunction = true;
          hero_slider.disable();
        } else {
          hero_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
          hero_slider.lockEdgeFunction = false;
          hero_slider.enable();
        }
        requestAnimationFrame(checkArticleContainerPosition);
      }
    }
    checkArticleContainerPosition();
  }
  window.addEventListener('load', initBlogSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', (e) => {
      const product_main_slider_elem = document.querySelector('media-gallery .swiper');
      const product_main_slider = new Swiper(product_main_slider_elem, {
        direction: 'vertical',
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        parallax: true,
        speed: 600,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: 'media-gallery .swiper-pagination',
        },
        on: {
          touchStart: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointerdown') {
                swiper._touch_start_y = evt.clientY;
              } else {
                swiper._touch_start_y = evt.touches[0].clientY;
              }
            }
          },
          touchMove: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointermove') {
                swiper._touch_move_y = evt.clientY;
              } else {
                swiper._touch_move_y = evt.touches[0].clientY;
              }
            }
          },
          touchEnd: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
                const delta_y = swiper._touch_move_y - swiper._touch_start_y;
                swiper._touch_start_y = null;
                swiper._touch_move_y = null;
                if (product_main_slider_elem.lock_edge_function == false) {
                  if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                    console.log('DOWN');
                    // mainSliderEdgeSlideNext();
                  } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                    console.log('UP');
                    // mainSliderEdgeSlidePrev();
                  }
                }
              }
            }
          },
          progress: (swiper, progress) => {
            if (progress < 0) {
              console.log('UP');
              // mainSliderEdgeSlidePrev();
            } else if (progress > 1) {
              // mainSliderEdgeSlideNext();
              const scrl_to = Math.max(
                document.scrollingElement.scrollTop,
                swiper.maxTranslate() * (progress - 1) * -2
              );
              document.scrollingElement.scrollTo({
                top: scrl_to,
                behavior: 'smooth',
              });
            }
          },
        },
      });

      function checkArticleContainerPosition() {
        const offset = 30;
        const articleContainer = document.querySelector('.product__info-wrapper');
        if (articleContainer) {
          const rect = articleContainer.getBoundingClientRect();
          if (rect.top < 0) {
            product_main_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
            product_main_slider.lockEdgeFunction = true;
            product_main_slider.disable();
          } else {
            product_main_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
            product_main_slider.lockEdgeFunction = false;
            product_main_slider.enable();
          }
          requestAnimationFrame(checkArticleContainerPosition);
        }
      }
      checkArticleContainerPosition();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-top-slider"] && !Shopify.designMode) return;
  try {
    
  function initIndexSliders() {
    const sub_sliders = document.querySelectorAll('.index-sub-slider');
    const header_control = document.querySelector('.header-slider-control');
    const header_control_inner = header_control.querySelector('.swiper-wrapper');
    const categories = [...sub_sliders].map((elem) => {
      return elem.dataset.categoryTitle;
    });
    categories.forEach((cat_title) => {
      const _button = document.createElement('BUTTON');
      const _span = document.createElement('SPAN');
      _button.classList.add('swiper-slide');
      _span.textContent = cat_title;
      _button.append(_span);
      header_control_inner.append(_button);
    });
    const header_control_swiper = new Swiper(header_control, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });
    const slider_main = new Swiper('.index-main-slider', {
      slidesPerView: 1,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      on: {
        slideChangeTransitionEnd: unlockEdgeFunction,
        init: (elem) => {
          setTimeout(() => {
            const _swiper = slider_main.slides[slider_main.activeIndex].querySelector('.swiper');
            if (_swiper.swiper != null) {
              const slides = _swiper.swiper.slides;
              const next_slide = slides[_swiper.swiper.activeIndex];
              if (next_slide.querySelector('video')) {
                const v = next_slide.querySelector('video');
                v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
                if (v.duration != null && v.duration > 0) {
                  next_slide.dataset.duration = v.duration * 1000;
                  sliderTimer(next_slide);
                } else {
                  v.addEventListener('timeupdate', subSliderVideoTimeHandler);
                }
                v.play();
              } else if (next_slide) {
                // ビデオがない場合はタイマーを開始
                sliderTimer(next_slide);
              }
            }
          }, 0);
        },
        transitionStart: (main_swiper) => {
          // スライダーのタイマーをリセット
          resetAllSubSlideTimers();
          const _swiper = main_swiper.slides[main_swiper.activeIndex].querySelector('.swiper');
          if (_swiper.swiper != null) {
            const slides = _swiper.swiper.slides;
            const next_slide = slides[_swiper.swiper.activeIndex];
            if (next_slide.querySelector('video')) {
              const v = next_slide.querySelector('video');
              // console.log(v.duration);

              v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
              if (v.duration != null && v.duration > 0) {
                next_slide.dataset.duration = v.duration * 1000;
                sliderTimer(next_slide);
              } else {
                v.addEventListener('timeupdate', subSliderVideoTimeHandler);
              }
              v.play();
            } else if (next_slide) {
              // ビデオがない場合はタイマーを開始
              if (next_slide) {
                sliderTimer(next_slide);
              }
            }
          } else {
            console.log(_swiper);
          }
        },
        transitionEnd: (main_swiper) => {
          const _swiper = main_swiper.slides[main_swiper.previousIndex].querySelector('.swiper');
          if (_swiper.swiper != null) {
            const slides = _swiper.swiper.slides;
            const prev_slide = slides[_swiper.swiper.activeIndex];
            if (prev_slide.querySelector('video')) {
              const v = prev_slide.querySelector('video');
              v.pause();
              v.currentTime = 0;
            }
          }
        },
      },
      rewind: true,
      thumbs: {
        swiper: header_control_swiper,
      },
    });

    function resetAllSubSlideTimers() {
      sub_sliders.forEach((sub_slider) => {
        const videos = sub_slider.querySelectorAll('video');
        videos.forEach((v) => {
          v.previousTime = 0;
          v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
        });
        const timer_slides = sub_slider.querySelectorAll('.has-timer');
        timer_slides.forEach((slide) => {
          if (slide.remove_timer != null && typeof slide.remove_timer === 'function') {
            slide.remove_timer();
          }
        });
      });
    }

    function updateSliderProgressIndicator(elem, progress) {
      const _slide = elem.closest('.swiper-slide');
      _slide.style.setProperty('--slide-timer-progress', progress);
    }

    function sliderTimer(elem) {
      // console.log('sliderTimer:', elem);
      const duration = elem.dataset.duration ? parseFloat(elem.dataset.duration) : 4000;
      const start_time = performance.now();
      let timer;
      let is_discarded = false;
      const update = (time) => {
        if (is_discarded) {
          return;
        }
        const elapsed = time - start_time;
        const progress = Math.min(elapsed / duration, 1);
        updateSliderProgressIndicator(elem, progress);
        if (progress < 1) {
          timer = requestAnimationFrame(update);
        } else {
          // Reset the timer when it reaches the end
          subSliderSlideNext(elem);
          updateSliderProgressIndicator(elem, 0);
        }
        // console.log('update sliderTimer:', elem, progress);
      };
      elem.remove_timer = function () {
        is_discarded = true;
        cancelAnimationFrame(timer);
        updateSliderProgressIndicator(elem, 0);
        elem.remove_timer = null;
        elem.classList.remove('has-timer');
        // console.log('remove sliderTimer:', elem);
      };
      requestAnimationFrame(update);
      elem.classList.add('has-timer');
    }

    function subSliderSlideNext(elem) {
      const sub_slider = elem.closest('.index-sub-slider');
      if (sub_slider && sub_slider.slider) {
        const next_index =
          sub_slider.slider.realIndex + 1 < sub_slider.slider.slides.length ? sub_slider.slider.realIndex + 1 : 0;
        sub_slider.swiper.slideTo(next_index, 600, false);
        if (next_index === 0) {
          // メインスライダーを次に進める
          mainSliderEdgeSlideNext();
        }
      }
    }

    function subSliderVideoTimeHandler(e) {
      const v = e.target;
      if (e.target.tagName.toLowerCase() != 'video') {
        return;
      }
      if (v.previousTime != null && v.currentTime < v.previousTime) {
        // Detect rewind
        v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
        v.previousTime = 0;
        subSliderSlideNext(e.target);
      } else {
        //
        v.previousTime = v.currentTime;
      }
      updateSliderProgressIndicator(v, v.currentTime / v.duration);
      // console.log(v.previousTime);
    }

    // header_control_swiper.controller.control = [slider_main];
    slider_main.controller.control = [header_control_swiper];

    function unlockEdgeFunction() {
      slider_main.lock_edge_function = false;
    }
    unlockEdgeFunction();

    function mainSliderEdgeSlidePrev() {
      const prev_index = slider_main.realIndex - 1 >= 0 ? slider_main.realIndex - 1 : slider_main.slides.length - 1;
      const active_sub_slider = sub_sliders[prev_index];
      slider_main.lock_edge_function = true;
      slider_main.slidePrev(400, true);

      if (active_sub_slider != null && typeof active_sub_slider.swiper != 'undefined') {
        active_sub_slider.swiper.slideTo(active_sub_slider.swiper.slides.length - 1, 600, false);
      }
    }

    function mainSliderEdgeSlideNext() {
      const next_index = slider_main.realIndex + 1 <= slider_main.slides.length - 1 ? slider_main.realIndex + 1 : 0;
      const active_sub_slider = sub_sliders[next_index];
      slider_main.lock_edge_function = true;
      slider_main.slideNext(400, true);

      if (active_sub_slider != null && typeof active_sub_slider.swiper != 'undefined') {
        active_sub_slider.swiper.slideTo(0, 600, false);
      }
    }

    sub_sliders.forEach((sub_slider) => {
      const pagination = sub_slider.querySelector('.index-sub-slider__pagination');
      function adjustPaginationPosition(swiper) {
        const pagination_rect = pagination.getBoundingClientRect();
        const scroll_height = pagination.scrollHeight;
        const position_adjust = swiper.activeIndex - swiper.previousIndex > 0 ? 3.5 : 0;
        const bullets = swiper.pagination.bullets;
        const active_bullet = bullets[Math.min(swiper.activeIndex, bullets.length - 1)];
        const active_bullet_rect = active_bullet.getBoundingClientRect();

        // console.log(
        //   position_adjust,
        //   pagination_rect.height,
        //   active_bullet_rect.top,
        //   pagination.scrollTop,
        //   scroll_height
        // );

        if (pagination_rect.height < scroll_height) {
          const pagination_st = pagination.scrollTop;
          const pagination_area_center = pagination_rect.height / 2 - pagination_rect.width * 3 * 0.5;
          const centered_scroll_position = Math.max(
            Math.min(
              pagination_st +
                active_bullet_rect.top -
                pagination_rect.top -
                pagination_area_center -
                position_adjust * pagination_rect.width,
              scroll_height
            ),
            0
          );
          // console.log(centered_scroll_position);
          pagination.classList.add('is-overflowed');
          pagination.scrollTo({ top: centered_scroll_position, behavior: 'smooth' });
        } else {
          pagination.classList.remove('is-overflowed');
          pagination.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
      sub_slider.slider = new Swiper(sub_slider, {
        direction: 'vertical',
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        parallax: true,
        speed: 600,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: pagination,
        },
        on: {
          touchStart: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointerdown') {
                swiper._touch_start_y = evt.clientY;
              } else {
                swiper._touch_start_y = evt.touches[0].clientY;
              }
            }
          },
          touchMove: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointermove') {
                swiper._touch_move_y = evt.clientY;
              } else {
                swiper._touch_move_y = evt.touches[0].clientY;
              }
            }
          },
          touchEnd: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
                const delta_y = swiper._touch_move_y - swiper._touch_start_y;
                swiper._touch_start_y = null;
                swiper._touch_move_y = null;
                if (slider_main.lock_edge_function == false) {
                  if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                    console.log('DOWN');
                    mainSliderEdgeSlideNext();
                  } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                    console.log('UP');
                    mainSliderEdgeSlidePrev();
                  }
                }
              }
            }
          },
          progress: (swiper, progress) => {
            if (slider_main.lock_edge_function == false) {
              if (progress < 0) {
                mainSliderEdgeSlidePrev();
              } else if (progress > 1) {
                mainSliderEdgeSlideNext();
              }
            }
          },
          transitionStart: (swiper) => {
            // スライダーのタイマーをリセット
            resetAllSubSlideTimers();

            const slides = swiper.slides;
            const next_slide = slides[swiper.activeIndex];
            if (next_slide.querySelector('video')) {
              const v = next_slide.querySelector('video');
              // console.log(v.duration);

              v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
              if (v.duration != null && v.duration > 0) {
                next_slide.dataset.duration = v.duration * 1000;
                sliderTimer(next_slide);
              } else {
                v.addEventListener('timeupdate', subSliderVideoTimeHandler);
              }
              v.play();
            } else if (next_slide) {
              // ビデオがない場合はタイマーを開始
              if (next_slide) {
                sliderTimer(next_slide);
              }
            }

            // ページネーションの位置を調整
            adjustPaginationPosition(swiper);
          },
          transitionEnd: (swiper) => {
            const slides = swiper.slides;
            const prev_slide = slides[swiper.previousIndex];
            if (prev_slide.querySelector('video')) {
              const v = prev_slide.querySelector('video');
              v.removeEventListener('timeupdate', subSliderVideoTimeHandler);
              v.pause();
              v.currentTime = 0;
            }
          },
        },
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initIndexSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initRelatedSlider);
  function initRelatedSlider() {
    const containers = document.querySelectorAll('product-recommendations');
    const config = { attributes: false, childList: true, subtree: false };

    containers.forEach((container) => {
      function init(mutationList, observer) {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            requestAnimationFrame(() => {
              const slider = container.querySelector('.swiper');
              const swiper = new Swiper(slider, {
                freeMode: true,
                slidesPerView: 'auto',
                mousewheel: true,
              });
            });
          }
        }
      }

      const observer = new MutationObserver(init);
      observer.observe(container, config);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
